import React,{useState} from "react";
import styled from "styled-components";
import theme from "../theme";
import {ReactComponent as IconoDown} from './../imagenes/down.svg';


const ContenedorSelect = styled.div`
    border-bottom: 2px solid ${theme.grisClaro2};
    cursor: pointer;
    text-transform: uppercase;
    position: relative;
    height: 3rem; /* 80px */
    width: 100%;
    padding: 0px 1.25rem; /* 20px */
    font-size: 1rem; /* 24px */
    text-align: center;
    display: flex;
    align-items: center;
    transition: .5s ease all;
    &:hover {
        background: ${theme.grisClaro};
    }
`;
const OpcionSeleccionada = styled.div`
    width: 100%;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        width: 1.25rem; /* 20px */
        height: auto;
        margin-left: 1.25rem; /* 20px */
    }
`;
const Opciones = styled.div`
    background: ${theme.grisClaro};
    position: absolute;
    top: 3.5rem; /* 90px */
    left: 0;
    width: 100%;
    border-radius: 0.625rem; /* 10px */
    max-height: 20rem; /* 300px */
    overflow-y: auto;
`;
const Opcion = styled.div`
    padding: 1.25rem; /* 20px */
    display: flex;
    svg {
        width: 28px;
        height: auto;
        margin-right: 1.25rem; /* 20px */
    }
    &:hover {
        background: ${theme.grisClaro2};
    }
`;

const SelectEstadoConductor = ({estado, cambiarEstado}) => {
const [mostrarSelect, cambiarMostrarSelect] = useState(false);
	
	const estados = [
        {id: 'aprobacion_central', texto: 'Aprobacion Central'},
        {id: 'activo', texto: 'Activo'},
        {id: 'validar_vehiculo', texto: 'Validar Vehiculo'},
        {id: 'cancelado', texto: 'Cancelado'},
    ]

	const handleClick = (e) => {
		cambiarEstado(e.currentTarget.dataset.valor);
	}

	return (
		<ContenedorSelect onClick={() => cambiarMostrarSelect(!mostrarSelect)}>
			<OpcionSeleccionada>{estado} <IconoDown /></OpcionSeleccionada>

			{mostrarSelect &&
				<Opciones>
					{estados.map((estado) => {
						return <Opcion 
									key={estado.id}
									data-valor={estado.id}
									onClick={handleClick}
								>
									{estado.texto}
								</Opcion>
					})}
				</Opciones>
			}
		</ContenedorSelect>
	);
}
 
export default SelectEstadoConductor;